<template>
  <div>
  <div class="row columns">
    <div class="large-12 text-left columns note mb-1">
      NB: cliquez sur la poubelle pour virer un joueur
    </div>
  </div>
      <table>
        <thead class="roster">
        <tr>
          <th width="2%">N°</th>
          <th width="10%">Nom</th>
          <th width="15%">Position</th>
          <th width="2%">M</th>
          <th width="2%">F</th>
          <th width="2%">Ag</th>
          <th width="2%">Ar</th>
          <th width="25%">Compétences</th>
          <th width="20%">Evolutions</th>
          <th width="8%">Xp</th>
          <th width="8%">Prix</th>
          <th></th>
        </tr>
        </thead>
        <tbody class="roster">
        <tr v-for="player in team.players">
          <td v-bind:class="{ miss: player.miss_next_game }" class="number">{{player.num}}</td>
          <td v-bind:class="{ miss: player.miss_next_game }" >{{player.name}}</td>
          <td v-bind:class="{ miss: player.miss_next_game }" >{{player.ref_roster_line}}</td>
          <td v-bind:class="{ miss: player.miss_next_game }" >{{player.M}}</td>
          <td v-bind:class="{ miss: player.miss_next_game }" >{{player.F}}</td>
          <td v-bind:class="{ miss: player.miss_next_game }" >{{player.Ag}}</td>
          <td v-bind:class="{ miss: player.miss_next_game }" >{{player.Ar}}</td>
          <td v-bind:class="{ miss: player.miss_next_game }" >
                                <span v-for="skill in player.skills" >
                                        {{skill.name}},
                                </span>
          </td>
          <td v-bind:class="{ miss: player.miss_next_game }" >
                                <span v-if="player.upgrades.length" v-for="up in player.upgrades" :class="helper.getUpgradeStyle(up)" >
                                        {{helper.getUpgradeName(up)}},
                                </span>
            <span v-if="player.downgrades" class="upgrade down">
                                        {{helper.getDowngrades(player)}},
                                </span>
            <div v-if="player.customizations && player.customizations.length"
                 v-for="cust in player.customizations" class="upgrade stats">
              <span v-if="cust.skills" v-for="skill in cust.skills">{{skill.name}}, </span>
            </div>
          </td>
          <td>{{player.total_xp}}</td>
          <td><span  v-bind:class="{ miss: player.miss_next_game }" class="additional_skills">{{player.base_cost + player.evolution_cost}}k</span></td>
          <td>
            <button v-if=isRevokable(player.id) :id="player.id" @click="addPlayerToFireList(player.id)" class="alert small action">
              <span><i class="fa fa-trash-o" aria-hidden="true"></i></span>
            </button>
            <button v-else :id="player.id" @click="removePlayerFromFireList(player.id)" class="small action">
              <span><i class="fa fa-undo" aria-hidden="true"></i></span>
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
</template>

<script>
  import th from '../../../common/team-helper'
  export default {
    name: 'player-revokes',
    data () {
      return {
        firePlayerList: []
      }
    },
    props: {
      team: {}
    },
    computed: {
      helper: function () {
        return th
      }
    },
    methods: {
      getPlayerToRevokeList () {
        return this.firePlayerList
      },
      isRevokable: function (playerId) {
        let foundIndex = this.firePlayerList.findIndex(pl => {
          return pl.id === playerId
        })
        return foundIndex === -1
      },
      addPlayerToFireList: function (id) {
        this.firePlayerList.push({'id': id})
        this.$emit('updatePlayerToRevoke')
      },
      removePlayerFromFireList: function (id) {
        let foundIndex = this.firePlayerList.findIndex(pl => {
          return pl.id === id
        })
        if (foundIndex === -1) {
          return
        }
        this.firePlayerList.splice(foundIndex, 1)
        this.$emit('updatePlayerToRevoke')
      }
    }
  }
</script>

<style scoped>
  .roster{
    font-weight: 300;
  }

  .roster tr:nth-of-type(odd) {
    transition: background-color 0.15s;
    background-color: #E9EDEF;
  }

  .roster tr:nth-of-type(even) {
    background-color: #ffffff;
  }

  /***** gestion des formats de cellules*/

  thead tr th {
    background-color: #ffffff;
    text-align: center;
    font-weight: 200;
    font-size:0.7rem;
    padding-left: 0.3rem;
    padding-right: 0.3rem;
  }

  .roster tr td{
    padding: 0.5rem 0rem;
    text-align: center;
    font-size:0.7rem;
  }

  .star tr td{
    padding: 0.5rem 0rem;
    text-align: center;
    font-size: 0.8rem;
    font-weight: 500;
    background-color: #E9EDEF;

  }
  .upgrade {
    font-weight: 600;
  }
  .stats {
    color: #882e8e
  }

  .down {
    color: #8e2625
  }

  .note {
    font-size: 0.8rem;
  }
  .mb-1 {
    margin-bottom: 1rem;
  }
  .small {
    margin-right: 0.3rem;
  }
  .roster tr td.action{
    padding: 0.4rem 0.3rem;
  }

  button.action {
    padding-left: 1rem;
    padding-right: 1rem;
    font-size: 0.8rem;
    font-weight: 600
  }
</style>



// WEBPACK FOOTER //
// player-revokes.vue?1718981e